import { type AuthBackendUpstreamVariant, AUTH_BACKEND_UPSTREAM_VARIANTS } from './constants'

export function getAuthBackendUrl(variant: AuthBackendUpstreamVariant): string | undefined {
  if (variant === AUTH_BACKEND_UPSTREAM_VARIANTS.AUTH_SERVER) {
    return process.env.AUTH_INTERNAL_URL || undefined
  }
  return undefined
}

export function getAuthServerUrl(): string | undefined {
  return process.env.AUTH_INTERNAL_URL || undefined
}
